// Check if a value is not contained in the array
export default function (value, collection, options) {
  if (!collection || !collection.length) {
    return options.fn(this);
  }
  if (collection.indexOf(value) > -1) {
    return options.inverse(this);
  }
  return options.fn(this);
}
